import { render, staticRenderFns } from "./afterSalesDocument.vue?vue&type=template&id=8bc7f6b0&scoped=true"
import script from "./afterSalesDocument.vue?vue&type=script&lang=js"
export * from "./afterSalesDocument.vue?vue&type=script&lang=js"
import style0 from "./afterSalesDocument.vue?vue&type=style&index=0&id=8bc7f6b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc7f6b0",
  null
  
)

export default component.exports